import {
  getStoredConsent,
  initialiseIframeConsent,
  isIframeMode,
  storeConsent
} from "../../services/cookieConsent/cookieConsentService";
import { isBrowser } from "../../utils/environment";
import { listenerMiddleware } from "../listenerMiddleware";
import {
  bannerShown,
  browserModeDetected,
  consentChosen,
  consentInitialisationRequested,
  consentResolved
} from "../slices/consentSlice";

export const registerConsentListeners = () => {
  listenerMiddleware.startListening({
    actionCreator: consentChosen,
    effect: (action) => {
      storeConsent(action.payload.analytics, action.payload.functional);
    }
  });

  listenerMiddleware.startListening({
    actionCreator: consentInitialisationRequested,
    effect: async (_, { dispatch }) => {
      if (!isBrowser()) {
        dispatch(
          consentResolved({
            isResolved: true,
            analytics: true,
            functional: true
          })
        );
        return;
      }

      if (isIframeMode()) {
        const consent = await initialiseIframeConsent();
        dispatch(consentResolved(consent));
        return;
      }

      dispatch(browserModeDetected());
      const storedConsent = getStoredConsent();
      if (storedConsent) {
        dispatch(consentResolved(storedConsent));
      } else {
        dispatch(bannerShown());
      }
    }
  });
};
